export enum CompSetSection {
  Overview = 'overview',
  RecentActivity = 'recentActivity',
  LeasingTrends = 'leasingTrends',
  Availabilities = 'availabilities',
  Performance = 'performance',
}

export const PROPERTY_PAGE_SECTIONS = {
  BUILDING_SUMMARY_KEY: 'building-summary',
  FUNDAMENTALS: 'fundamentals',
  BUILDING_INFO_KEY: 'building-info',
  RECENT_ACTIVITY_KEY: 'recent-activity',
  COMP_SET_KEY: 'comp-set',
  NEARBY_AMENITIES_KEY: 'nearby-amenities',
  DEMOGRAPHICS_KEY: 'demographics',
};

export const PROPERTY_PAGE_SUB_SECTIONS = {
  ATTRIBUTES_KEY: 'attributes',
  PERFORMANCE_KEY: 'performance',
  AVAILABILITIES_KEY: 'availabilities',
  LEASING_KEY: 'leasing',
  SALES_KEY: 'sales',
};
